import { takeLatest, call, put } from "redux-saga/effects"
import { push } from "connected-react-router"
import { orderBy } from "lodash"
import {
  listSurveysSuccess,
  listSurveysFailed,
  listMeasurementsSuccess,
  listMeasurementsFailed,
  listMeasurementsWatcher,
  hasCollaboratorsSuccess,
} from "./actions"
import {
  CREATE_MEASUREMENT_WATCHER,
  LIST_SURVEYS_WATCHER,
  LIST_MEASUREMENTS_WATCHER,
  DELETE_MEASURE_WATCHER,
  HAS_COLLABORATORS_WATCHER,
} from "./constants"
import { getSurveyWatcherApi } from "../Survey/saga"
import { createMeasureSegment } from "../../utils/segment/Measure/measureTrack"
import { LOCAL_COMPANY_ID } from "../../utils/storage"

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

// CREATE MEASUREMENT
export function* createMeasurementWatcherSaga(action) {
  try {
    const { status, data } = yield call(fetchGlobalApi, {
      method: "POST",
      endpoint: "measure",
      data: action.payload,
    })

    const survey = yield call(getSurveyWatcherApi, action.payload.id_survey)
    if (status === 200) {
      createMeasureSegment(action.payload.name, survey.data.data.survey)
      yield put(push(`/models/measure-create/${data.measure_id}`))
    }
  } catch (error) {
    returnMessage(error)
  }
}

// LIST MEASURES
export function* listMeasurementsWatcherSaga() {
  try {
    const { status, data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `companies/${LOCAL_COMPANY_ID()}/measure?all-data=false`,
    })

    if (status === 200) {
      yield put(listMeasurementsSuccess(data.data.measure))
    }
  } catch (error) {
    yield put(listMeasurementsFailed())
    returnMessage(error)
  }
}

// LIST SURVERYS
export function* listSurveysWatcherSaga() {
  try {
    const { status, data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `companies/${LOCAL_COMPANY_ID()}/available-surveys`,
    })

    if (status === 200) {
      yield put(listSurveysSuccess(data.data))
    }
  } catch (error) {
    yield put(listSurveysFailed())
  }
}

// DELETE MEASURE
export function* deleteMeasureSaga(action) {
  try {
    const { status, data } = yield call(fetchGlobalApi, {
      method: "DELETE",
      endpoint: `measure/${action.payload}`,
    })

    if (status === 200) {
      yield put(listMeasurementsWatcher())

      yield call(messageSuccess, "Medición eliminada.")
    }
  } catch (error) {
    returnMessage(error)
  }
}

// HAS COLLABORATORS
export function* hasCollaboratorsSaga() {
  try {
    const { status, data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `companies/${LOCAL_COMPANY_ID()}/has/employees`,
    })

    if (status === 200) {
      yield put(hasCollaboratorsSuccess(data))
    }
  } catch (e) {}
}

// Individual exports for testing
export default function* measurementHistorySaga() {
  yield takeLatest(CREATE_MEASUREMENT_WATCHER, createMeasurementWatcherSaga)
  yield takeLatest(LIST_SURVEYS_WATCHER, listSurveysWatcherSaga)
  yield takeLatest(LIST_MEASUREMENTS_WATCHER, listMeasurementsWatcherSaga)
  yield takeLatest(DELETE_MEASURE_WATCHER, deleteMeasureSaga)
  yield takeLatest(HAS_COLLABORATORS_WATCHER, hasCollaboratorsSaga)
}
